export default {
  path: '/:type/appdetail/*',
  auth: true,
  preload: false,
  key: 'appdetail',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
